import { useState } from "react";
import { Modal } from "react-bootstrap";
import AlertBox from "../AlertBox";
import { downloadPerformanceProject } from "../../api/infrastructure";
import MonthYearPicker from "../MonthYearPicker";
import { useAllPartnersHooks } from "../../utils/project/PartnerUtils";
import { useGroupListHooks } from "../../utils/ProjectsUtilHooks";

export default function ModalDownloadPerformanceReport({ show, onClose, onSuccess }) {
  const { partners } = useAllPartnersHooks();
  const { projects } = useGroupListHooks();
  let [form, setForm] = useState({ partner_id: "", project_id: "", start_month: "", end_month: "" });
  let [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });

  const handleClose = () => {
    setForm({ partner_id: "", project_id: "", start_month: "", end_month: "" });
    setAlert({ show: false, message: "", type: "" });
    onClose(false);
  };

  const changeMonthYearFilter = (name, value) => {
    setForm({ ...form, [name]: value });
  };

  const submitData = (event) => {
    event.preventDefault();
    downloadDataPerformance(form);
  };

  const downloadDataPerformance = async (form) => {
    setLoading(true);
    try {
      let response = await downloadPerformanceProject({ ...form });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Report Project Performance.xlsx");
      onSuccess(true, "Berhasil mengunduh Report Project Performance.xlsx");
      document.body.appendChild(link);
      link.click();
      handleClose();
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({ show: true, message, type: "danger" });
    }

    setLoading(false);
  };
  return (
    <Modal show={show} onHide={() => handleClose()}>
      <form onSubmit={(event) => submitData(event)}>
        <Modal.Header closeButton>
          <Modal.Title>Download Project Performance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AlertBox {...alert} setAlert={setAlert} />
          <div className="form-group">
            <label htmlFor="downloadPerformancePartnerFilter">Mitra</label>
            <select
              className="form-control"
              id="downloadPerformancePartnerFilter"
              value={form.partner_id}
              onChange={(event) => setForm({ ...form, partner_id: event.target.value })}
            >
              <option value="">SEMUA</option>
              {partners.map((partner) => (
                <option key={partner.id} value={partner.id}>
                  {partner.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="downloadPerformanceProjectFilter">Grup/Project</label>
            <select
              className="form-control"
              id="downloadPerformanceProjectFilter"
              value={form.project_id}
              onChange={(event) => setForm({ ...form, project_id: event.target.value })}
            >
              <option value="">SEMUA</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Bulan/Tahun mulai</label>
            <MonthYearPicker
              value={form.start_month}
              changeMonthYear={(value) => changeMonthYearFilter("start_month", value)}
            />
          </div>
          <div className="form-group">
            <label>Bulan/Tahun Akhir</label>
            <MonthYearPicker
              value={form.end_month}
              changeMonthYear={(value) => changeMonthYearFilter("end_month", value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" type="button" onClick={() => handleClose()}>
            Close
          </button>
          <button className="btn btn-primary" type="submit" disabled={loading}>
            <i className="fas fa-download"></i> {!loading ? "Unduh Data" : "Harap Tunggu ..."}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
